import { render, staticRenderFns } from "./MessengerContactListSwitcher.vue?vue&type=template&id=1d2efd66"
import script from "./MessengerContactListSwitcher.vue?vue&type=script&lang=js"
export * from "./MessengerContactListSwitcher.vue?vue&type=script&lang=js"
import style0 from "./MessengerContactListSwitcher.vue?vue&type=style&index=0&id=1d2efd66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports